// CreateCompsetPage.jsx - identical to CompsetSetupPage but separate path
import Compset from '@/components/Compset';

export default function CreateCompsetPage() {
    return <Compset mode="update" />;
}